/* eslint-disable no-underscore-dangle */
import { LoadingController, NavController, NavParams, Platform, ToastController, ModalController } from '@ionic/angular';
import { Component, Renderer2, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../../../../authentication-service';
import { adjustViewZIndex, getDistanceInKM } from '../../../../globals';
import { ClubInfo, ClubList, createClubList } from '../../../../data/club-course';
import { GeolocationService } from '../../../../providers/geolocation-service/geolocation-service';
import { ClubService } from '../../../../providers/club-service/club-service';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { PlayerService } from '../../../../providers/player-service/player-service';
import { Country } from '../../../../data/country-location';
import { SessionDataService } from '../../../../redux/session';
import { SessionInfo } from '../../../../data/authentication-info';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { ClubData, ClubDataPage, ExtClubData, createClubDataPage } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { CommonPullupMenuComponent, PullupMenuData } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';

// import {ClubFilterPage} from '../club-filter/club-filter';
/**
 * The competition list page class. This class lists the competitions. There are
 * three types of listing
 * <ul>
 *    <li>Upcoming</li>
 *    <li>All Competitions</li>
 *    <li>Search competitions</li>
 *  </ul>
 *  This class extends Subscriber which is passed as parameter for Remote Http method so that
 *  results are processed
 */
@Component({
  templateUrl: 'club-list.page.html',
  selector: 'club-list-page',
  styleUrls: ['club-list.page.scss'],
  providers: [Keyboard]
})
export class ClubListPage implements OnInit {

  clubList: ClubList;
  clubDataPage: ExtClubData;
  openedModal: boolean = false;
  searchQuery: string = '';
  countryList: Array<Country>;
  @Input() countryId: string;
  flagUrl: string;
  countryData: Country;
  session: SessionInfo;
  forMembership: boolean = false;
  filteredClubType: string;
  @Input() hideClubType: boolean = false;

  constructor(private nav: NavController,
    private renderer: Renderer2,
    private navParams: NavParams,
    private auth: AuthenticationService,
    private geo: GeolocationService,
    private clubService: ClubService,
    private loadCtl: LoadingController,
    private toastCtl: ToastController,
    private keyboard: Keyboard,
    private platform: Platform,
    private modalCtl: ModalController,
    private playerService: PlayerService,
    private sessionService: SessionDataService,
    private flightService: ClubFlightService) {
    this.clubList = createClubList();
    this.clubDataPage = createClubDataPage();
    this.openedModal = navParams.get('openedModal');
    this.forMembership = navParams.get('forMembership');
    this.filteredClubType = navParams.get("filteredClubType");
    console.log(this.clubList,'--this.clubList Constru')
  }

  ngOnInit() {
    this.sessionService.getSession()
      .pipe()
      .subscribe((session: SessionInfo) => {
        this.session = session;

      });
    this.countryId = this.session.countryId;
    this.goRefreshClubs();
    this.getCountry();
    console.log(this.clubList,'--this.clubList ONINt')
  }

  ionViewDidEnter() {
    if (!this.openedModal) {
      adjustViewZIndex(this.nav, this.renderer);
    }
  }

  onSearchInput() {
    this._clearItems();
    this.goRefreshClubs();
  }

  /**
   * Gets the distance between a current location and club in KMs
   * @param club The club information
   * @returns {number} Returns the distance in KM if GPS locations of current and club are available
   * else returns 0;
   */
  clubDistance(club: ClubInfo): string {
    const lat1 = this.geo.getLatitude();
    const lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null) { return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + ' KM'; }
    return '';
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick(refresher) {
    this._clearItems();
    this.goRefreshClubs(refresher)
  }

  goRefreshClubs(refresher?, infinite?) {
    if(this.forMembership) {
      this._refreshClubsNew(refresher, infinite);
    } else {
      this._refreshClubs(refresher, infinite);
    }
  }

  doInfinite(infinite) {

    if (this.isMore()) {
      this.goRefreshClubs(null, infinite)
    }else {
      infinite.target.complete();
      // infinite.target.disabled = true;
    }

  }

  clubSelected(event, item: ClubInfo | ClubData) {
    if (this.openedModal) {
      this.modalCtl.dismiss(item);
    }
  }

  close() {
    this.modalCtl.dismiss();
  }

  private _clearItems() {
    this.clubList = createClubList();
    this.clubDataPage = createClubDataPage();
  }

  private _filterVirtualClubs() {
    if (this.clubList.clubs.length > 0) {
      this.clubList.clubs = this.clubList.clubs.filter((x: ClubInfo) => {
        return !x.virtualClub
      })

    }
  }

  private _refreshClubs(refresher, infinite) {
    // let busy = this.loadCtl.create({
    //     content: "Please wait..."
    // });
    // busy.present().then(()=>{
    this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1, this.countryId)
      .subscribe((clubList: ClubList) => {
        // busy.dismiss().then(()=>{
        this.clubList.currentPage = clubList.currentPage;
        this.clubList.totalPages = clubList.totalPages;
        this.clubList.totalItems = clubList.totalItems;
        this.clubList.clubs.push(...clubList.clubs);
        if (!this.forMembership) { this._filterVirtualClubs(); }

        // });

      }, (error) => {
        // busy.dismiss().then(()=>{
        const msg = MessageDisplayUtil.getErrorMessage(error, 'Error getting club list');
        MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
        // })
      }, () => {
        console.log("FINISH")
        //Handle the refresher or infinite
        if (refresher && refresher.complete) { refresher.complete(); }
        console.log('infinite: ', infinite);
        if (infinite) {
          console.log("--Infinite--", infinite)
          if (infinite) { infinite.target.complete(); }
          if (this.isMore()) {
            if (infinite) { infinite.target.enable(true); }
          }
          else {
            if (infinite) { infinite.target.enable(false); }
          }
        }
        if (this.platform.is('ios') || this.platform.is('capacitor')) { this.keyboard.hide(); }
      });
    // });

  }


  private _refreshClubsNew(refresher, infinite) {
    // this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1, this.countryId, true)
    if(!infinite) this._clearItems();
    let _clubType = 'B';
    if(this.filteredClubType?.toLowerCase().includes('socialclub')) _clubType = 'S';
    else if(this.filteredClubType?.toLowerCase().includes('golfclub')) _clubType = 'G';
    this.flightService.searchClubsNew(this.searchQuery, true, this.clubDataPage.currentPage + 1, this.countryId, 30, _clubType)
      .subscribe((clubDataPage: ClubDataPage) => {
        // busy.dismiss().then(()=>{
        this.clubDataPage.currentPage = clubDataPage.currentPage;
        this.clubDataPage.totalPages = clubDataPage.totalPages;
        this.clubDataPage.totalItems = clubDataPage.totalItems;
        this.clubDataPage.items.push(...clubDataPage.items);
        this.clubDataPage.clubs.push(...clubDataPage.items);
        if (!this.forMembership) this._filterVirtualClubs();

        // });

      }, (error) => {
        // busy.dismiss().then(()=>{
        let msg = MessageDisplayUtil.getErrorMessage(error, "Error getting club list");
        MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, "bottom");
        // })
      }, () => {
        //Handle the refresher or infinite
        if (refresher) refresher.target.complete();
        if (infinite) infinite.target.complete();
        if (this.platform.is('ios') || this.platform.is('capacitor'))
          this.keyboard.hide();
      });
    // });

  }

  isMore(): boolean {
    if(this.forMembership) {
      console.debug(this.forMembership, " is more : ", this.clubDataPage)
      return this.clubDataPage && this.clubDataPage.totalPages > 0
        && this.clubDataPage.currentPage < this.clubDataPage.totalPages;
    } else {
      console.debug(this.forMembership, " is more : ", this.clubList)
      return this.clubList && this.clubList.totalPages > 0
        && this.clubList.currentPage < this.clubList.totalPages;
    }
    // return this.clubList && this.clubList.totalPages > 0
    //   && this.clubList.currentPage < this.clubList.totalPages;
  }

  // onMenuFilterClick() {
  //     let filter = this.modalCtl.create(ClubFilterPage);
  //     filter.onDidDismiss((apply: boolean) => {
  //         if (apply) this._refreshClubs(null, null);
  //     })
  //     // this.nav.push(ClubFilterPage);
  //     if (this.platform.is('ios') && this.platform.is('capacitor'))
  //         this.keyboard.close();
  //     filter.present();
  // }

  getCountry() {
    this.playerService.getCountryList()
      .subscribe((data: Array<Country>) => {

        this.countryList = data;

      });
  }



  selectCountryName:any=null;
  async countrySelected() {

    const modal = await this.modalCtl.create({
      component:DeleteRoomModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
          mode:'selectClub',
          countryList:this.countryList,
          countryId:this.countryId,
          header:'Select Country'
      },
      showBackdrop:true,
      mode:'ios'
  })
  modal.present();
  modal.onDidDismiss().then((data)=>{
      if(data?.data){
        this.selectCountryName = null;
        this.countryId = data?.data?.id;
        // this.selectCountryName = data?.data?.name
        this.selectCountryName = data?.data
        this._clearItems();
        this.goRefreshClubs(null,null)
        console.log("Data",data)
      }
  })

  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl === null || flagUrl === '') { return null }
    else {
      const flagIcon = flagUrl.split('/')
      return 'assets/img/flag/' + flagIcon[2]

    }
  }

  getClubList() {
    let _filteredList = [];
    if(this.forMembership) {
      _filteredList = this.clubDataPage.clubs;
    } else {
      _filteredList = this.clubList.clubs;
    }
    return _filteredList;
  }

  getClubAddress(club: ClubData) {
    let _address = [];
    // if(club?.address?.city) _address.push(club?.address?.city);
    if(club?.address?.state) _address.push(club?.address?.state);
    if(club?.address?.countryData?.name) _address.push(club?.address?.countryData.name);
    return _address.join(", ");
  }
  getClubTypeName() {
    if(this.filteredClubType === 'socialClub') return 'Social Clubs';
    else if(this.filteredClubType === 'golfClub') return 'Golf Clubs';
    else return 'All Clubs';
  }
  async clubTypeSelected() {

    let _dataList: Array<PullupMenuData> = [];
    _dataList.push({
      id: 'socialClub',
      name: 'Social Clubs',
    })
    _dataList.push({
      id: 'golfClub',
      name: 'Golf Clubs',
    })
    _dataList.push({
      id: 'all',
      name: 'All Club Types',
    })

    const modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      // this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
          mode:'common',
          header:'Select Club Type',
          dataList: _dataList,
      },
      showBackdrop:true,
      mode:'ios'
      })
      modal.present();
      modal.onDidDismiss().then((data)=>{
          if(data?.data){
            this.filteredClubType = data?.data?.id;
            this._clearItems();
            this.goRefreshClubs(null,null)
          }
      })
  }
}
